import React from 'react'
import TopHeader from '../Header/TopHeader'
import Navbar from '../Header/Navbar'
import Footer from '../Footer/Footer'
import { Helmet } from 'react-helmet-async'
import '../Css/Contact.css'
import Breadcrumb from '../Screens/Breadcrumb'

function Contact() {
    return (
        <>
            <Helmet>
                <title>Contact Compliancekare | GST | ITR | Project Report</title>
                <meta name="description" content="Get in touch with Compliancekare for GST, Income Tax filing, company registration, accounting, and complete business compliance services." />
                <meta name="keywords" content="Reach out to Compliancekare for GST, ITR filing, company setup, accounting, and end-to-end compliance services for your business." />
            </Helmet>
            <TopHeader />
            <Navbar />
            <Breadcrumb title="Contact Us" pageName="Contact" />
            <section className="contact-section" style={{ background: "white", padding: "15px" }}>
                <div className="container">
                    <div className="row" style={{ display: "flex" }}>
                        <div className="contact-info">
                            <div className="contact-info-item">
                                <div className="contact-info-content" >
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Address</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>1st Floor, D 159, D Block, Sector 7, Noida, Uttar Pradesh 201301<br />
                                        </p>
                                </div>
                            </div>
                            <div className="contact-info-item">
                                <div className="contact-info-content">
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Landline No</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>+91 11 4760 2267</p>
                                </div>
                                <div className="contact-info-content">
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Mobile No</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>+91 9625758585</p>
                                </div>
                            </div>
                            <div className="contact-info-item">
                                <div className="contact-info-content">
                                    <h4 style={{ fontFamily: "poppins", fontSize: "25px" }}>Email</h4>
                                    <p style={{ fontFamily: "poppins", fontSize: "20px" }}>INFO@COMPLIANCEKARE.COM</p>
                                </div>
                            </div>
                        </div>
                        <div className="contact-form">
                            <form action="" id="contact-form">
                                <h2 style={{ color: "rgb(137, 199, 100)" }}>Send Message</h2>
                                <div className="input-box">
                                    <input type="text" required={true} name="" />
                                    <span>Full Name</span>
                                </div>

                                <div className="input-box">
                                    <input type="email" required={true} name="" />
                                    <span>Email</span>
                                </div>

                                <div className="input-box">
                                    <textarea required={true} name=""></textarea>
                                    <span>Type your Message...</span>
                                </div>

                                <div className="input-box">
                                    <input type="submit" value="Send" name="" />
                                </div>
                            </form>
                        </div>

                    </div>
                </div>
            </section>
            <Footer />
        </>
    )
}

export default Contact